import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialBox from '../../components/MaterialBox'
import MaterialTypography from '../../components/MaterialTypography'
import { Tooltip, Grid, Card, CardContent, Box, Stack, Chip, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../Utils/Baseurl'
import { useLoading } from '../../context/loadingcontext'
import MaterialButton from '../../components/MaterialButton'


const TaskCreationNew = () => {
    const navigate = useNavigate();
    const { setCirleLoading } = useLoading();
    const [sampleProjects, setSampleProjects] = useState([]);


    useEffect(() => {
        fetchProjectsList();
    }, []);

    const fetchProjectsList = async () => {
        const token = sessionStorage.getItem("token");
        const user = JSON.parse(sessionStorage.getItem("currentUser"));
        try {
            setCirleLoading(true);
            const response = await axios.post(`${BASE_URL}api/project-list-by-userid/`,
                {
                    "user_id": user
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            setSampleProjects(response.data.data);
        } catch (error) {
            console.log(error);
        } finally {
            setCirleLoading(false);
        }
    }

    return (
        <DashboardLayout>
            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 2, padding: 1 }}>
                <MaterialTypography variant='h5' color='dark' fontWeight='bold'>
                    Task Creation
                </MaterialTypography>
                <MaterialTypography variant='caption' color='textSecondary'>
                    You can create a list of task based on the project you select.
                </MaterialTypography>
            </MaterialBox>

            <MaterialBox p={1}>
                <Grid container spacing={2}>
                    {sampleProjects?.map((project) => {
                        const needsRebaseline = project.current_baseline_total_tasks > 0;
                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 2.4, lg: 2.4 }} key={project.project_id}>
                                <Card
                                    sx={{
                                        borderRadius: '20px',
                                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
                                        // transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                        // '&:hover': {
                                        //     transform: 'translateY(-5px)',
                                        //     boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                                        // },
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '100%'
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: '#bec7f8ff',
                                            padding: 2,
                                            textAlign: 'left',
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.02)'
                                        }}
                                    >
                                        <Tooltip title={project.project_name || project.projectName || ''}>
                                            <MaterialTypography
                                                variant="h6"
                                                sx={{
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    color: '#333',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    mb: 1
                                                }}
                                            >
                                                {(project.project_name || project.projectName || 'Untitled Project').length > 18
                                                    ? (project.project_name || project.projectName || 'Untitled Project').substring(0, 18) + '...'
                                                    : (project.project_name || project.projectName || 'Untitled Project')}
                                            </MaterialTypography>
                                        </Tooltip>

                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Chip
                                                label={needsRebaseline ? 'Needs Rebaseline' : 'Tasks Freezed'}
                                                sx={{
                                                    backgroundColor: needsRebaseline ? '#ef5350' : '#81c784',
                                                    color: '#fff',
                                                    fontWeight: 500,
                                                    fontSize: '11px',
                                                    height: '24px',
                                                    boxShadow: needsRebaseline ? '0 4px 10px rgba(244, 67, 54, 0.2)' : '0 4px 10px rgba(76, 175, 80, 0.2)'
                                                }}
                                            />
                                            <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium">
                                                Baseline: {project.current_baseline_count || 0}
                                            </MaterialTypography>
                                        </Box>
                                    </Box>


                                    <CardContent sx={{ flexGrow: 1, padding: 2 }}>
                                        <Stack spacing={1.5}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Planned Tasks:</MaterialTypography>
                                                <MaterialTypography variant="body2" color="textPrimary" fontWeight="bold" sx={{ fontSize: '12px' }}>{project.total_initial_tasks || 0} tasks</MaterialTypography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Planned Hours:</MaterialTypography>
                                                <MaterialTypography variant="body2" color="textPrimary" fontWeight="bold" sx={{ fontSize: '12px' }}>{project.total_assigned_hours || 0} hrs</MaterialTypography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Rebaseline Tasks:</MaterialTypography>
                                                <MaterialTypography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    color={needsRebaseline ? 'error.main' : 'textPrimary'}
                                                    sx={{ fontSize: '12px' }}
                                                >
                                                    {project.current_baseline_total_tasks || 0} tasks
                                                </MaterialTypography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Rebaseline Hours:</MaterialTypography>
                                                <MaterialTypography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    color={project.current_baseline_hours > 0 ? 'error.main' : 'textPrimary'}
                                                    sx={{ fontSize: '12px' }}
                                                >
                                                    {project.current_baseline_hours || 0} hrs
                                                </MaterialTypography>
                                            </Box>
                                            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Freeze Status:</MaterialTypography>
                                                <MaterialTypography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    color={project.pending_freeze ? 'error.main' : 'textPrimary'}
                                                    sx={{ fontSize: '12px' }}
                                                >
                                                    {project.pending_freeze}
                                                </MaterialTypography>
                                            </Box> */}
                                        </Stack>
                                    </CardContent>


                                    <Box sx={{ padding: '0 20px 20px 20px' }}>
                                        <MaterialButton
                                            fullWidth
                                            size="small"
                                            variant="contained"
                                            onClick={() => navigate('/task-creation/task-list', { state: { project_id: project.project_id } })}
                                            sx={{
                                                backgroundColor: '#5f6ec2',
                                                color: '#fff',
                                                borderRadius: '12px',
                                                padding: '10px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                                '&:hover': {
                                                    backgroundColor: '#4a5699',
                                                    transform: 'translateY(-2px)'
                                                }
                                            }}
                                        >
                                            View Task List
                                        </MaterialButton>
                                        
                                    </Box>
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>

                {(!sampleProjects || sampleProjects.length === 0) && (
                    <MaterialBox sx={{ textAlign: 'center', mt: 4, color: 'text.secondary' }}>
                        <MaterialTypography variant='body1'>No projects found.</MaterialTypography>
                    </MaterialBox>
                )}
            </MaterialBox>
        </DashboardLayout>
    )
}

export default TaskCreationNew